import { render, staticRenderFns } from "./FormTemplateTextQuestion.vue?vue&type=template&id=66c15f12&scoped=true&"
import script from "./FormTemplateTextQuestion.vue?vue&type=script&lang=js&"
export * from "./FormTemplateTextQuestion.vue?vue&type=script&lang=js&"
import style0 from "./FormTemplateTextQuestion.vue?vue&type=style&index=0&id=66c15f12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c15f12",
  null
  
)

export default component.exports